import * as courses from "./courses";
import * as classrooms from "./classrooms";
import * as bots from "./bots";
import * as roleplays from "./roleplays";
import * as users from "./users";
import * as completions from "./completions";
import * as progress from "./progress";
import * as notifications from "./notifications";
import * as sessionReports from "./sessionReports";

export {
  courses,
  classrooms,
  bots,
  roleplays,
  users,
  completions,
  progress,
  notifications,
  sessionReports,
};
